export default "__VITE_ASSET__CqyrwCWQ__"